// extracted by mini-css-extract-plugin
export default {"horizontalAd":"ads_horizontalAd__fAcJA"};